
import useBreakpoint from "hooks/useBreakpoint";

export default function BreakpointComponent({ DesktopView, MobileView }) {
  if (!DesktopView || !MobileView) {
    throw new Error(
      "BreakpointComponent requires both a DesktopView and a MobileView component. " +
        `Received: DesktopView=${!!DesktopView}, MobileView=${!!MobileView}`
    );
  }

  const { isMobile } = useBreakpoint();

  if (isMobile) return <MobileView />;
  return <DesktopView />;
}
